var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("leo-progress-stepper", {
    attrs: { steps: _vm.getCurrentStep, activeStep: `${_vm.currentStep}` },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }